<template>
  <section>
    <!-- 暂时去除tab -->
    <van-sticky v-if="false" @scroll="scroll">
      <ul class="tabbar">
        <li
          class="tabbar-item"
          @click="select(item)"
          :class="{
            active: scrollIndex === item.id,
            'pf-medium': scrollIndex === item.id
          }"
          v-for="(item, index) in tabs"
          :key="index"
        >
          {{ item.title }}
        </li>
      </ul>
    </van-sticky>
    <div class="serve_title pf-medium">{{ tabtitle }}</div>
  </section>
</template>

<script>
import { Sticky } from 'vant'
import { mapState } from 'vuex'
import TAB_TYPE from './config'
import { getTabTitle } from '../../product/product-intro/config'

export default {
  components: {
    [Sticky.name]: Sticky
  },
  props: {
    scrollIndex: {
      type: String,
      default: TAB_TYPE.TAB_DETAIL
    }
  },
  mounted() {
    //更换标题
    this.tabs[0].title = getTabTitle(
      this.product.spuType,
      this.product.level4CategoryId
    )
  },
  data() {
    return {
      tabs: [
        { title: '服务详情', id: TAB_TYPE.TAB_DETAIL },
        { title: '购买须知', id: TAB_TYPE.TAB_NOTICE }
      ]
    }
  },
  computed: {
    ...mapState(['commentCount', 'otherServiceDatas', 'product']),
    tabtitle() {
      return getTabTitle(this.product.spuType, this.product.level4CategoryId)
    }
  },
  methods: {
    scroll(args) {
      // this.$emit("scroll", {...args , tabs:this.tabs});
    },
    select(item) {
      this.$emit('update:scrollIndex', item.id)
      // this.scrollIndex = item.id;
      this.$emit('change', item)
    }
  },
  watch: {
    commentCount(val) {
      if (
        val > 0 &&
        this.tabs.findIndex(i => i.id === TAB_TYPE.TAB_COMMENT) < 0
      ) {
        if (this.tabs.length === 3) {
          this.tabs.splice(2, 0, {
            title: '用户评价',
            id: TAB_TYPE.TAB_COMMENT
          })
        } else {
          this.tabs.push({ title: '用户评价', id: TAB_TYPE.TAB_COMMENT })
        }
      }
    },
    otherServiceDatas(val) {
      if (
        val.length > 0 &&
        this.tabs.findIndex(i => i.id === TAB_TYPE.TAB_PRODUCT) < 0
      ) {
        this.tabs.push({ title: '其他推荐', id: TAB_TYPE.TAB_PRODUCT })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.serve_title {
  background-color: white;
  padding: rem(32px) rem(30px) 0;
  font-size: rem(32px);
  color: #121212;
}

.tabbar {
  display: flex;
  height: rem(84px);
  background-color: white;
  justify-content: center;

  .tabbar-item {
    color: #262626;
    display: flex;
    justify-content: center;
    font-size: rem(30px);
    text-align: center;
    flex: 1;
    align-items: center;
  }
  .active {
    box-sizing: content-box;
    color: #121212;
    font-size: rem(30px);
    position: relative;
    &:after {
      display: block;
      content: '';
      position: absolute;
      height: rem(6px);
      background: #ff5900;
      width: rem(36px);
      border-radius: rem(6px);
      bottom: rem(10px);
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
